/* eslint-disable no-unused-vars */
import React from 'react';
import { TextField, Typography, FormControl, FormHelperText, Tooltip , IconButton, Box} from '@mui/material';
import { makeStyles } from '@mui/styles';
import './styles.scss';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const useStyles = makeStyles(theme => ({
  formControl: {
    minWidth: '100%',
  },
  errorRed: {
    color: '#f44336',
  },
  infoIcon: {
    marginLeft: '4px',
    fontSize: '16px',
    color: 'grey',
  }
}));

export default function Input(props) {
  const {
    name, value, label, required, placeholder, variant = 'outlined', error = null, size = 'small', fullWidth, type = '', tooltipTitle = '', rightTooltipTitle = null, tooltipClasses, labelSx, onChange, onKeyPress, ...others
  } = props;
  const classes = useStyles();

  return (
    <FormControl variant={variant} className={classes.formControl}>
      {label &&
        <><Box display="flex" alignItems="center">
          <Typography
          component="p"
          className={required ? 'inputLabel required' : 'inputLabel'}
          sx={labelSx}
          >{label}
          </Typography>
          {rightTooltipTitle && <Tooltip title={rightTooltipTitle} className={classes.infoIcon}  placement="top-start" >
              <IconButton size="small">
                <InfoOutlinedIcon fontSize="small" />
              </IconButton>
          </Tooltip>}
        </Box></>
      }
      <Tooltip title={tooltipTitle} arrow classes={{ tooltip: tooltipClasses }}>
        <TextField
          placeholder={placeholder}
          variant="outlined"
          name={name}
          onChange={onChange}
          onKeyDown={onKeyPress}
          type={type}
          size={size}
          fullWidth={fullWidth}
          InputLabelProps={{
            shrink: true,
          }}
          value={value}
           inputProps={{
            maxLength: others.maxLength, // ✅ This enables character limit
          }}
          {...others}
          {...(error && { error: 'true', helpertext: error })}
        />
      </Tooltip>
      <FormHelperText className={classes.errorRed}>{error && error}</FormHelperText>
      {/* <FormHelperText>{error && error}</FormHelperText> */}
    </FormControl>
  );
}
